"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrap = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../Thanks/styles");
const IconWrap = exports.IconWrap = (0, _mui.styled)(_styles.IconWrap)(({
  theme
}) => ({
  color: theme.palette.error.main
}));
